import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Modal } from "@mui/material";

import { CompressedImage } from "@/components/common/CompressedImage";

type ZoomModalProps = {
  open: boolean;
  imageSrc: string | null;
  onClose: () => void;
};

const modalStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

const closeButtonStyles = {
  position: "absolute",
  top: 8,
  right: 8,
  color: "white",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  "&:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.7)",
  },
};

const imageStyles = {
  maxHeight: "90vh",
  maxWidth: "90vw",
  objectFit: "contain" as const,
  borderRadius: 2,
  boxShadow: "0 8px 20px rgba(0,0,0,0.3)",
};

export function ZoomModal({ open, imageSrc, onClose }: ZoomModalProps) {
  if (!imageSrc) return null;

  return (
    <Modal open={open} onClose={onClose} sx={modalStyles}>
      <Box sx={{ position: "relative", outline: "none" }}>
        <IconButton onClick={onClose} sx={closeButtonStyles}>
          <CloseIcon />
        </IconButton>
        <CompressedImage image={{ url: imageSrc }} alt="Zoomed Image" sx={imageStyles} />
      </Box>
    </Modal>
  );
}
